import $ from 'jquery';

function instagramApi() {
    var api = 'https://www.instagram.com/reflectionstpete/?__a=1';

    $.getJSON(
    api,
      function (data) {
          var src = data.graphql.user.edge_owner_to_timeline_media.edges;
          for(var imgs in src) {
          var ig = 'https://www.instagram.com/p/';
          var shortcode = src[imgs].node.shortcode;
          var img_src = src[imgs].node.thumbnail_src;
          var img = '<img class="instagram-feed-slider_image" src="'+ img_src +'" alt="">'
          $(".instagram-feed-slider").slick("slickAdd", '<a target="_blank" href=' + ig + shortcode +'><div>'+ img +'</div></a>');
        }
      }
    )
};

export { instagramApi };